import { allEnumValues, IntegrationSystem, OrderChannel, ReportType } from '@biteinc/enums';

export namespace ReportHelper {
  export function getAvailableReportTypes(
    isOneTimeReport: boolean,
    sessionUser: any,
    org: any,
    site: any,
    location: any,
    settings: any,
  ): ReportType[] {
    const reportTypes: ReportType[] = [];

    if (sessionUser.canViewOrders()) {
      reportTypes.push(ReportType.LoyaltySignups);
      reportTypes.push(ReportType.SalesGuests);
      reportTypes.push(ReportType.FutureOrders);
      reportTypes.push(ReportType.SalesOrders);
      reportTypes.push(ReportType.SalesTransactions);
      reportTypes.push(ReportType.ThirdPartyOrders);
      reportTypes.push(ReportType.EightySixingActivity);
      reportTypes.push(ReportType.CouponRedemptionHistory);
      reportTypes.push(ReportType.LoyaltyLoginAttempts);
      reportTypes.push(ReportType.OrderInsertionRate);
      if (sessionUser.isBite()) {
        reportTypes.push(ReportType.ItemUpsell);
        reportTypes.push(ReportType.DayUpsell);
        reportTypes.push(ReportType.LoyaltyUsage);
        reportTypes.push(ReportType.OrderConversionRate);
        reportTypes.push(ReportType.PilotEngagement);
        reportTypes.push(ReportType.PilotLaborAnalysis);
        reportTypes.push(ReportType.VitrineSessionMetrics);
        if (location && location.hasIntegrationWithSystem(IntegrationSystem.Punchh)) {
          reportTypes.push(ReportType.PunchhLocationOrders);
        }
        if ((site && location) || !site) {
          reportTypes.push(ReportType.KOR);
        }
      }
      if (location) {
        if (isOneTimeReport) {
          reportTypes.push(ReportType.SalesSummaryModal);
        }
        reportTypes.push(ReportType.SalesSummaryChannel);
        if (org.get('customerAccountsScope') && settings.get('customerAccountsUsage')) {
          reportTypes.push(ReportType.CustomerOrders);
        }
      } else if (site) {
        reportTypes.push(ReportType.SalesSummarySite);
      } else {
        reportTypes.push(ReportType.SalesSummaryOrg);
        if (sessionUser.isBite()) {
          reportTypes.push(ReportType.KioskUsageOverlap);
        }
        if (sessionUser.isBite() && isOneTimeReport) {
          reportTypes.push(ReportType.IndustryBenchmark);
        }
        if (isOneTimeReport) {
          reportTypes.push(ReportType.KioskPeripherals);
        }
        const orgHasStripe =
          org.hasIntegrationWithSystem(IntegrationSystem.Stripe) ||
          org.hasIntegrationWithSystem(IntegrationSystem.StripeTerminal);
        if (orgHasStripe) {
          reportTypes.push(ReportType.FlashPayouts);
        }

        if (org.get('customerAccountsScope')) {
          reportTypes.push(ReportType.CustomerOrders);
        }
      }
    }

    if (location) {
      const locationHasStripe =
        location.hasIntegrationWithSystem(IntegrationSystem.Stripe) ||
        location.hasIntegrationWithSystem(IntegrationSystem.StripeTerminal);
      if (locationHasStripe) {
        reportTypes.push(ReportType.VendorPayouts);
      }
    }

    return reportTypes;
  }

  export function getAvailableOrderChannels(): OrderChannel[] {
    let locations: (typeof app.locationList.models)[number][];

    if (app.location) {
      locations = [app.location];
    } else if (app.site) {
      locations = app.locationList.getLocationsWithSiteId(app.site.id as string);
    } else {
      if (!app.locationList.hasBeenFetched()) {
        // We don't know which order channels are available yet; return all of them.
        return allEnumValues(OrderChannel);
      }

      locations = app.locationList.models;
    }

    return Array.from(
      new Set(
        locations
          .filter((location) => {
            return !location.isBiteOnly();
          })
          .map((location) => {
            return location.get('orderChannel');
          })
          .filter((orderChannel): orderChannel is OrderChannel => orderChannel !== undefined),
      ),
    );
  }
}
